<template>
    <div class="login flex-box">
        <div class="login-logo"></div>
        <div class="login-box">
            <div class="login-box-ti">手机验证码登录</div>
            <a-form-model
              class="login-form"
              ref="loginForm"
              :model="form"
              :rules="rules"
              :label-col="{span: 0}"
              :wrapper-col="{span: 25}">
                <a-form-model-item label="" prop="mobile">
                    <a-input size="large" v-model="form.mobile" placeholder="手机号码" @keyup.enter="login">
                        <a-icon slot="prefix" type="user"/>
                    </a-input>
                </a-form-model-item>
                <a-form-model-item label="" prop="code">
                    <a-input size="large" v-model="form.code" placeholder="验证码" @keyup.enter="login">
                        <a-icon slot="prefix" type="lock" />
                        <div slot="addonAfter" class="get-verify-btn" @click="getVerifyCode">{{ second > 0 ? `重新获取(${second}s)` : '获取验证码'}}</div>
                    </a-input>
                </a-form-model-item>
            </a-form-model>
            <a-button size="large" type="primary" block @click="login">登录</a-button>
            <div class="login-loading" v-show="loading">
                <a-spin tip="正在登陆...">
                    <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
                </a-spin>
            </div>
        </div>
    </div>
</template>

<script>
    import {setToken, cleanToken} from "../common/js/storage";

    export default {
        name: "Login",
        data() {
            return {
                form: {},
                rules: {
                    mobile: [
                        { required: true, message: '请输入手机号码', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    code: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                },
                sending: false,
                loading: false,
                img: null,
                token: null,
                second: 0
            }
        },
        created() {
            cleanToken();
        },
        methods: {
            getVerifyCode() {
                if(this.sending) return;
                this.$refs.loginForm.validateField('mobile', error => {
                    if(!error) {
                        this.sending = true;
                        this.$axios({
                            url: "/admin/login/get-verify-code",
                            method: 'POST',
                            data: {
                                mobile: this.form.mobile
                            }
                        }).then(res => {
                            if(res.error == 0) {
                                this.$message.success('验证码已发送');
                                this.second = 60;
                                let timer = setInterval(() => {
                                    if(this.second > 0){
                                        this.second --;
                                    } else {
                                        clearInterval(timer);
                                        this.second = 0; //重置时间
                                    }
                                }, 1000);
                            } else {
                                this.$message.warning(res.msg);
                            }
                        }).catch((err) => {
                            console.error(err);
                        }).finally(() => {
                            this.sending = false;
                        })
                    }
                });
            },
            login() {
                this.$refs.loginForm.validate(valid => {
                    if (valid) {
                        let form = this.form;
                        this.loading = true;
                        this.$axios({
                            url: '/admin/login/auth',
                            method: "POST",
                            data: {
                                mobile: form.mobile,
                                code: form.code
                            }
                        }).then(res => {
                            this.loading = false;
                            let code = res.error;
                            if(code == 0) {
                                this.$message.success('登录成功');
                                setToken(res);
                                location.replace(this.$route.query.r || "/");
                            } else {
                                this.$message.error(res.msg);
                            }
                        }).catch(() => {
                            this.loading = false;
                            // this.$message.error("您的账号密码不匹配");
                        });
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style scoped lang="less">
    .login {
        align-items: flex-start;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: url(../assets/login-logo.png) center no-repeat,
          url(../assets/login-back.png) center no-repeat, #ffffff;
        background-size: 1143px 1080px, cover;
    }
    .login-logo {
        position: absolute;
        top: 32px;
        left: 160px;
        width: 110px;
        height: 64px;
        background: url(../assets/logo.png) center / contain no-repeat;
    }
    .login-title {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 64px;
        padding: 0 @padding-lg;
        h3 {
            margin: 0;
            line-height: 1;
        }
    }
    .sep {
        margin: 0 12px;
        width: 1px;
        height: 16px;
        background-color: @text-color-secondary;
    }
    .login-box {
        position: relative;
        margin-top: 200px;
        padding: @padding-lg;
        background-color: @body-background;
        box-shadow: @box-shadow-base;
        border-radius: 4px;
    }
    .login-box-ti {
        font-size: 20px;
        text-align: center;
    }
    .login-form {
        margin-top: 24px;
        width: 300px;
    }
    .code-img-box {
        margin-right: -12px;
        position: relative;
        width: 76px;
        height: 38px;
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
        overflow: hidden;
        font-size: 0;
        text-align: center;
    }
    .code-img {
        width: 100%;
        height: 100%;
    }
    .login-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(255,255,255,.6);
        cursor: pointer;
    }
    .wx-login-btn {
        display: block;
        margin-top: 16px;
    }
    .get-verify-btn {
        margin: 0 -11px;
        padding: 0 10px;
        width: 110px;
        height: 38px;
        line-height: 38px;
        cursor: pointer;
    }
</style>
